import { ReactNode } from 'react';

import { Step, Stepper, Stack } from '@cast/design-system';

import { BaseInstanceSelector } from './BaseInstanceSelector';
import { useClmCompatibleFamiliesPicker } from './ClmCompatibleFamiliesPickerProvider';
import { CompatibleInstancesSelector } from './CompatibleInstancesSelector';
import { SelectionSummary } from './SelectionSummary';

type ClmCompatibleFamiliesPickerProps = {
  header?: ReactNode;
  summaryHeader?: ReactNode;
};

export const ClmCompatibleFamiliesPicker = ({
  header,
  summaryHeader,
}: ClmCompatibleFamiliesPickerProps) => {
  const { activeStep } = useClmCompatibleFamiliesPicker();

  return (
    <>
      {header}

      <Stack flexGrow={1} direction="row" gap={64} pt={32} overflow="hidden">
        <Stack minWidth={333} width={333} gap={24}>
          {summaryHeader}
          <SelectionSummary />
        </Stack>

        <Stack flexGrow={1} direction="row" gap={16}>
          <Stepper
            size="small"
            orientation="vertical"
            sx={{
              height: 144,
              '& .MuiStepConnector-root': {
                ml: 11,
              },
              '& .MuiStepConnector-line': {
                height: '100%',
              },
            }}
            activeStep={activeStep}
          >
            <Step />
            <Step />
          </Stepper>

          <Stack gap={40}>
            <BaseInstanceSelector />
            <CompatibleInstancesSelector />
          </Stack>
        </Stack>
      </Stack>
    </>
  );
};
